
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export const usePostChecklistBE = (url) => {

    const [postData, setPostData] = useState("");
    const [submittingBE,setSubmittingBE] = useState(false);
    const [postStatus, setPostStatus] = useState(false);
    const isFirstRender = useRef(true);
    const ref =  useRef(false);
    let navigate = useNavigate();    

    const handleRedirect = () => {
      window.location.href =
        window.location.href + "&submit.jotform.com/submit";
    };
    const postFn = (postval) => {
     // console.log("postval",postval)
      setSubmittingBE(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postval)
          };
          //console.log("request",requestOptions);      
          fetch(url, requestOptions)
          .then(resp => resp.json())
          .then(data => {
            setPostData(data)
            setPostStatus(data.status)
            setSubmittingBE(false);    
           // console.log("setStatus22",data.status)
            // if(submittingBE === false){
            //     if(data.status){
            //         Swal.fire({
            //           icon: "success",
            //           confirmButtonColor: '#652078',
            //           text: `Successfully Submitted`
            //         }).then((res) => {
            //           if (res) {
            //             window.close();
            //             //handleRedirect();
            //           }
            //         });
            //       }else if(!data.status){
            //         Swal.fire({
            //             icon: "error",
            //             text: data.message
            //           }).then((res) => {
            //             if (res) {
            //             //navigate(`/`);
            //             }
            //           });
            //     }
            // }
          });
      } 
    
    
      useEffect(() => {
        if(ref.current) return;
        if(isFirstRender.current){
            isFirstRender.current = false;
        }else{
          postFn();
        }
        ref.current = true;
      },[])
    


    return [postData,postFn,submittingBE,postStatus]
}